import React from "react";
import './styles.css'
import { useNavigate } from 'react-router-dom';

const ScreenLabel = ({ label, showBackButton = true }) => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <div className="sl-parent-container" onClick={() => {
            if (showBackButton === true) {
                handleGoBack()
            }
        }}>
            {showBackButton && <div className="sl-img-container">
                <img src={require('../../../assets/ic_back_icon.png')} className="img" />
            </div>}
            <div className="screen-label">
                {label}
            </div>
        </div>

    )
}

export default ScreenLabel